/**
 * Servers Service - Irrigo Platform
 * Servicio para gestión de servidores MQTT y LNS
 */

import { api, ApiResponse, PaginatedResponse } from './api';
import type { 
  ApiMQTTServer, 
  CreateMQTTServerRequest, 
  UpdateMQTTServerRequest,
  ApiLNSServer,
  CreateLNSServerRequest,
  UpdateLNSServerRequest,
} from '@/types/api';

// ============================================================================
// SERVERS SERVICE
// ============================================================================

export const serversService = {
  // ==========================================================================
  // MQTT SERVERS
  // ==========================================================================

  /**
   * Listar servidores MQTT
   * ACTUALIZADO: Backend ahora devuelve formato paginado { items: [], pagination: {} }
   */
  async getMQTTServers(): Promise<PaginatedResponse<ApiMQTTServer>> {
    return api.getPaginated<ApiMQTTServer>('/mqtt-servers');
  },

  /**
   * Obtener servidor MQTT por ID
   */
  async getMQTTServerById(id: string): Promise<ApiResponse<ApiMQTTServer>> {
    return api.get<ApiMQTTServer>(`/mqtt-servers/${id}`);
  },

  /**
   * Crear servidor MQTT
   */
  async createMQTTServer(data: CreateMQTTServerRequest): Promise<ApiResponse<ApiMQTTServer>> {
    return api.post<ApiMQTTServer>('/mqtt-servers', data);
  },

  /**
   * Actualizar servidor MQTT
   */
  async updateMQTTServer(id: string, data: UpdateMQTTServerRequest): Promise<ApiResponse<ApiMQTTServer>> {
    return api.put<ApiMQTTServer>(`/mqtt-servers/${id}`, data);
  },

  /**
   * Eliminar servidor MQTT
   */
  async deleteMQTTServer(id: string): Promise<ApiResponse<{ message: string }>> {
    return api.delete<{ message: string }>(`/mqtt-servers/${id}`);
  },

  // ==========================================================================
  // LNS SERVERS
  // ==========================================================================

  /**
   * Listar servidores LNS
   * ACTUALIZADO: Backend ahora devuelve formato paginado { items: [], pagination: {} }
   */
  async getLNSServers(): Promise<PaginatedResponse<ApiLNSServer>> {
    return api.getPaginated<ApiLNSServer>('/lns-servers');
  },

  /**
   * Obtener servidor LNS por ID
   */
  async getLNSServerById(id: string): Promise<ApiResponse<ApiLNSServer>> {
    return api.get<ApiLNSServer>(`/lns-servers/${id}`);
  },

  /**
   * Crear servidor LNS
   */
  async createLNSServer(data: CreateLNSServerRequest): Promise<ApiResponse<ApiLNSServer>> {
    return api.post<ApiLNSServer>('/lns-servers', data);
  },

  /**
   * Actualizar servidor LNS
   */
  async updateLNSServer(id: string, data: UpdateLNSServerRequest): Promise<ApiResponse<ApiLNSServer>> {
    return api.put<ApiLNSServer>(`/lns-servers/${id}`, data);
  },

  /**
   * Eliminar servidor LNS
   */
  async deleteLNSServer(id: string): Promise<ApiResponse<{ message: string }>> {
    return api.delete<{ message: string }>(`/lns-servers/${id}`);
  },
};

export default serversService;
